import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
const NAME_MAX = 30;
const truncateName = (s) => s && s.length > NAME_MAX ? s.substring(0, NAME_MAX).trimEnd() + '…' : s;
// Highlight mode helpers — a Category opcionalis color + highlightSlug mezojebol
// epitjuk a pill markup class-eit + inline style-jat. A Branding rendszerbol per-slug
// CSS hivatkozas tarsithato a pillhez (`category_pill_highlighted_<slug>` stb.).
// A regi `highlight_pill*` branding kompatibilitasahoz alias class-eket is rakunk.
function buildPillClasses(base, c) {
    if (!c.highlightSlug)
        return base;
    const slug = c.highlightSlug;
    return `${base} career-category-pill-highlighted career-category-pill-highlighted-${slug} career-highlight-pill`;
}
function buildNameClasses(c) {
    const base = 'career-category-pill-name';
    if (!c.highlightSlug)
        return base;
    const slug = c.highlightSlug;
    return `${base} career-category-pill-name-highlighted career-category-pill-name-highlighted-${slug} career-highlight-name`;
}
function buildCountClasses(c) {
    const base = 'career-category-pill-count';
    if (!c.highlightSlug)
        return base;
    const slug = c.highlightSlug;
    return `${base} career-category-pill-count-highlighted career-category-pill-count-highlighted-${slug} career-highlight-count`;
}
function buildImageClasses(c) {
    const base = 'career-category-pill-image';
    if (!c.highlightSlug)
        return base;
    const slug = c.highlightSlug;
    return `${base} career-category-pill-image-highlighted career-category-pill-image-highlighted-${slug}`;
}
function buildPillStyle(c, base) {
    if (!c.color)
        return base;
    return { ...(base || {}), backgroundColor: c.color, borderColor: c.color };
}
export function CategoryList({ categories, mode = 'text_image', onSelect, leadingItem }) {
    if ((!categories || categories.length === 0) && !leadingItem)
        return null;
    const handleClick = (e, catId) => {
        if (onSelect) {
            e.preventDefault();
            onSelect(catId);
        }
    };
    // Mode 1 + Mode 2: egységes pill rendszer
    //  - text mode: egysoros pill (név balra + count badge jobbra)
    //  - text_image mode (c.image van): vertikális blokk (kép felül + alatta sor: kis név balra + count jobbra)
    //  - név mindkét mode-ban max 30 karakter, fölötte "…"
    if (mode === 'text' || mode === 'text_image') {
        const showImage = mode === 'text_image';
        return (_jsx("section", { className: "career-categories my-8", children: _jsxs("ul", { className: "career-category-list", children: [leadingItem && (_jsx("li", { className: "career-category-item", children: leadingItem }, "__leading__")), categories.map(c => {
                        const hasImg = showImage && !!c.image;
                        const displayName = truncateName(c.name);
                        if (hasImg) {
                            return (_jsx("li", { className: "career-category-item", children: _jsxs("a", { href: `?category=${c.id}`, className: buildPillClasses('career-category-pill career-category-pill-with-image', c), style: buildPillStyle(c), onClick: e => handleClick(e, c.id), title: c.name, children: [_jsx("span", { className: buildImageClasses(c), style: { backgroundImage: `url(${c.image})` }, "aria-hidden": "true" }), _jsxs("span", { className: "career-category-pill-row", children: [_jsx("span", { className: buildNameClasses(c), children: displayName }), _jsx("span", { className: buildCountClasses(c), children: c.count })] })] }) }, c.id));
                        }
                        return (_jsx("li", { className: "career-category-item", children: _jsxs("a", { href: `?category=${c.id}`, className: buildPillClasses('career-category-pill', c), style: buildPillStyle(c), onClick: e => handleClick(e, c.id), title: c.name, children: [_jsx("span", { className: buildNameClasses(c), children: displayName }), _jsx("span", { className: buildCountClasses(c), children: c.count })] }) }, c.id));
                    })] }) }));
    }
    // Mode 3: csak kép overlay-szöveggel (full-bleed)
    return (_jsx("section", { className: "career-categories my-8", children: _jsxs("div", { className: "grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4", children: [leadingItem && (_jsx("div", { className: "career-category-image-card-wrap", children: leadingItem }, "__leading__")), categories.map(c => {
                    const displayName = truncateName(c.name);
                    const baseStyle = c.image
                        ? { backgroundImage: `url(${c.image})`, backgroundSize: 'cover', backgroundPosition: 'center' }
                        : { background: '#cbd5e1' };
                    // Highlight mode: a kerete-szin override (a card border-jet adja meg a highlight)
                    const finalStyle = c.color ? { ...baseStyle, border: `2px solid ${c.color}` } : baseStyle;
                    const slug = c.highlightSlug || '';
                    const extraClasses = slug
                        ? ` career-category-pill-highlighted career-category-pill-highlighted-${slug} career-highlight-pill`
                        : '';
                    return (_jsx("a", { href: `?category=${c.id}`, className: `career-category-image-card relative h-32 rounded overflow-hidden block${extraClasses}`, style: finalStyle, onClick: e => handleClick(e, c.id), title: c.name, children: _jsxs("div", { className: "career-category-image-overlay absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white p-2 text-center text-sm inline-flex items-center justify-center gap-2", children: [_jsx("span", { className: `font-medium${slug ? ` career-category-pill-name-highlighted career-category-pill-name-highlighted-${slug} career-highlight-name` : ''}`, children: displayName }), _jsx("span", { className: buildCountClasses(c), children: c.count })] }) }, c.id));
                })] }) }));
}
